export default __webpack_public_path__ + "static/media/yellow.b8f593fd.jpg";